import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { GungTextInputComponent } from '../gung-text-input/gung-text-input.component';
import { BaseInputDirective } from '../base-input/base-input.directive';

@Component({
    selector: 'lib-gung-radio-button-input-horizontal',
    templateUrl: './gung-radio-button-input-horizontal.component.html',
    styleUrls: ['./gung-radio-button-input-horizontal.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GungRadioButtonInputHorizontalComponent),
            multi: true
        }
    ],
    standalone: false
})
export class GungRadioButtonInputHorizontalComponent extends BaseInputDirective<string> {
  @Input()
  public labelClass: string | string[];

  @Input()
  public radioGroupName: string;

  @Input()
  public divClass: string | string[];

  @Input()
  public buttonValue: string;

  onRadioChange(event: any) {
    if (event.target.checked) {
      this.value = this.buttonValue;
      this.onChange(this.buttonValue);
      this.onTouched();
    }
  }
}
